var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            { staticClass: "justify-content-between" },
            [
              _c(
                "b-col",
                {
                  staticClass: "my-1",
                  attrs: { cols: "12", md: "2", sm: "1" },
                },
                [
                  _c(
                    "b-form-group",
                    { staticClass: "mb-0" },
                    [
                      _c(
                        "label",
                        { staticClass: "d-inline-block text-sm-left mr-50" },
                        [_vm._v("Per page")]
                      ),
                      _c("b-form-select", {
                        attrs: {
                          id: "perPageSelect",
                          size: "sm",
                          options: _vm.pageOptions,
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function ($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-end my-1",
                  attrs: { md: "6" },
                },
                [
                  _vm.HasPermission(_vm.PermissionList.HRMS_Create)
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            to: { name: "add-employee" },
                          },
                        },
                        [
                          _c("feather-icon", { attrs: { icon: "PlusIcon" } }),
                          _vm._v(" New Employee "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mb-2 my-1",
                  staticStyle: { position: "relative", "z-index": "1" },
                  attrs: { cols: "12" },
                },
                [
                  _vm.HasPermission(_vm.PermissionList.HRMS_Search)
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      items: _vm.filteredEmployees,
                      fields: _vm.fields,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                      "sort-direction": _vm.sortDirection,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      filtered: _vm.onFiltered,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "head(firstName)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSort("firstName")
                                      },
                                    },
                                  },
                                  [_vm._v("Name")]
                                ),
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Name",
                                    size: "sm",
                                  },
                                  on: { input: _vm.applyFilters },
                                  model: {
                                    value: _vm.filters.firstName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "firstName", $$v)
                                    },
                                    expression: "filters.firstName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "head(departmentName)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSort("departmentName")
                                      },
                                    },
                                  },
                                  [_vm._v("Department")]
                                ),
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Department",
                                    size: "sm",
                                  },
                                  on: { input: _vm.applyFilters },
                                  model: {
                                    value: _vm.filters.departmentName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filters,
                                        "departmentName",
                                        $$v
                                      )
                                    },
                                    expression: "filters.departmentName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "head(designationName)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSort("designationName")
                                      },
                                    },
                                  },
                                  [_vm._v("Designation")]
                                ),
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Designation",
                                    size: "sm",
                                  },
                                  on: { input: _vm.applyFilters },
                                  model: {
                                    value: _vm.filters.designationName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filters,
                                        "designationName",
                                        $$v
                                      )
                                    },
                                    expression: "filters.designationName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "head(email)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSort("email")
                                      },
                                    },
                                  },
                                  [_vm._v("Email")]
                                ),
                                _c("b-form-input", {
                                  attrs: {
                                    placeholder: "Filter by Email",
                                    size: "sm",
                                  },
                                  on: { input: _vm.applyFilters },
                                  model: {
                                    value: _vm.filters.email,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "email", $$v)
                                    },
                                    expression: "filters.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "head(hireDate)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSort("hireDate")
                                      },
                                    },
                                  },
                                  [_vm._v("Joining Date")]
                                ),
                                _c("DatePicker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    range: "",
                                    format: "YYYY-MM-DD",
                                    placeholder: "Select date range",
                                  },
                                  on: { change: _vm.applyFilters },
                                  model: {
                                    value: _vm.filters.hireDateRange,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filters,
                                        "hireDateRange",
                                        $$v
                                      )
                                    },
                                    expression: "filters.hireDateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "head(status)",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c("span", [_vm._v(_vm._s(scope.label))]),
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.statusFilterOptions,
                                    size: "sm",
                                  },
                                  model: {
                                    value: _vm.filters.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filters, "status", $$v)
                                    },
                                    expression: "filters.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(firstName)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatName(data.item)) + " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(hireDate)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(data.item)) + " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (data) {
                          return [
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "m-1",
                                attrs: {
                                  variant: "link",
                                  "toggle-class": "p-0",
                                  "no-caret": "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function () {
                                        return [
                                          _c("feather-icon", {
                                            staticClass:
                                              "align-middle text-body",
                                            attrs: {
                                              icon: "MoreVerticalIcon",
                                              size: "16",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm.HasPermission(_vm.PermissionList.HRMS_View)
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: {
                                            name: "view-employee",
                                            params: { id: data.item.id },
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EyeIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("View")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.HasPermission(_vm.PermissionList.HRMS_Edit)
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: {
                                          to: {
                                            name: "edit-employee",
                                            params: { id: data.item.id },
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.HasPermission(
                                  _vm.PermissionList.HRMS_Delete
                                ) && data.item.status !== "ACTIVE"
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.ActivateEmployee(
                                              "ACTIVE",
                                              data.item.id,
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "CheckCircleIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Activate")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.HasPermission(
                                  _vm.PermissionList.HRMS_Delete
                                ) && data.item.status !== "INACTIVE"
                                  ? _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.DeactivateEmployee(
                                              "INACTIVE",
                                              data.item.id,
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "XCircleIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Deactivate")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "b-modal",
                    {
                      ref: "editLeaveRequest",
                      attrs: {
                        id: "modal-edit-leave-request",
                        "ok-only": "",
                        "ok-title": "Edit",
                        centered: "",
                        size: "lg",
                        title: "Edit Leave Request",
                        "hide-footer": true,
                      },
                    },
                    [
                      _c("EditLeaveRequest", {
                        on: { refresh: _vm.refreshData },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center",
                      size: "sm",
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }